<template>
  <div style="margin-top: 8rem">
    <!-- <el-scrollbar style="height:100%">   -->
    <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs" stretch>
      <el-tab-pane  label="关于我们" name="first" class="tabs_item">
        <el-row class="center">
          <div v-for="(contact, i) in first">
            <router-link to="/about">
              <el-button
                class="bt"
                type="primary"
                plain
                @click="goToAnchorPoint(contact.idx)"
                >{{ contact.title }}</el-button
              >
            </router-link>
          </div>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="产品与服务" name="second" class="tabs_item">
        <el-row class="center">
          <div v-for="(contact, i) in second">
            <el-button
              class="bt"
              type="primary"
              plain
              @click="goLink(contact.path)"
              >{{ contact.title }}</el-button
            >
          </div>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="新闻中心" name="third" class="tabs_item">
        <el-row class="center">
          <div v-for="(contact, i) in third">
            <el-button
              class="bt"
              type="primary"
              plain
              @click="goLink(contact.path)"
              >{{ contact.title }}</el-button
            >
          </div>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="加入我们" name="fourth" class="tabs_item">
        <el-row class="center">
          <div v-for="(contact, i) in fifth">
            <el-button
              class="bt"
              type="primary"
              plain
              @click="goLink(contact.path)"
              >{{ contact.title }}</el-button
            >
          </div>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="投资者关系" name="fifth" class="tabs_item">
        <el-row class="center">
          <div v-for="(contact, i) in fourth">
            <el-button
              class="bt"
              type="primary"
              plain
              @click="goLink(contact.path)"
              >{{ contact.title }}</el-button
            >
          </div>
        </el-row>
      </el-tab-pane>
    </el-tabs>
    <!-- </el-scrollbar> -->
  </div>
</template>
<script>
import api from '@/utils/api'
export default {
  data () {
    return {
      activeName: 'first',

      first: [
        { idx: 'one', title: '公司概况', path: '/about' },
        // { idx: 'two', title: '发展历程', path: '/about' },
        { idx: 'three', title: '企业文化', path: '/about' },
        { idx: 'four', title: '公司荣誉', path: '/about' },
      ],

      second: [
        { idx: 1, title: '半导体显示智能装备', path: '/services' },
        { idx: 2, title: '小尺寸显示面板生产设备', path: '/services' },
        { idx: 3, title: 'MEMS传感器智能装备', path: '/services' },
        { idx: 4, title: '智能工厂系统解决方案', path: '/services' },
        { idx: 5, title: '其他智能制造生产设备', path: '/services' },
        { idx: 6, title: '工装/冶具', path: '/services' },
      ],

      third: [
        { idx: 1, title: '公司新闻', path: '/news/new' },
        { idx: 2, title: '行业资讯', path: '/news/msg' },
      ],

      fourth: [
        { idx: 1, title: '股票信息', path: '/investor/shares' },
        // { idx: 2, title: '财务信息', path: '/investor/finance' },
        { idx: 3, title: '公司公告', path: '/investor/notice' },
        { idx: 4, title: '投资者互动', path: '/investor/interaction' },
      ],

      fifth: [
        { idx: 1, title: '欢迎致辞', path: '/join/welcome' },
        { idx: 2, title: '招聘岗位', path: '/join/recruit' },
      ],
    }
  },
  methods: {
    //   通过path跳转到对应页面查找对应id跳转对应位置
    goToAnchorPoint (idx) {
      let select = idx
      localStorage.setItem('id', select)
      this.$router.push({ name: 'ConfigurationManage' })
    },
    handleClick (tab, event) {
    //   var styleElement = document.getElementsByClassName('el-tabs__nav is-top is-stretch');
    //   console.log(styleElement)
    //   console.log(this.activeName)
    //   if (this.activeName == 'second') {
    //     console.log(this.$refs.navScroll)
    //   }
    //   if (this.activeName == 'fourth') {
    //   }
      // console.log(event)
    },
    goLink (e) {
      this.$router.push(e)
    },
  },
}
</script>
<style scoped>
/deep/ .el-tabs__item {
  font-size: 1.75rem;
}
/* 按钮之间的距离 按钮内部样式*/
/deep/ .bt {
  margin-top: 2rem;
  height: 5.625rem;
  width: 43.875rem;
  font-size: 1.875rem;
  color: #0099da !important;
  border-radius: 0.5rem;
}
/deep/ .el-button {
  background: -webkit-gradient(
    linear,
    100% 0%,
    0% 0%,
    from(#e9f4ff),
    to(#ffffff)
  ) !important;
  color: #fff;
}
/deep/ .el-tabs__nav-scroll {
    overflow-x: scroll;
  height: 5.5rem;
}
/deep/ .tabs_item {
  width: 46.875rem !important;
}
/deep/ .el-tabs__item {
  width: 11.75rem;
  height: 4.625rem;
  text-align: center;
}
/* 消除自带边框 */
/deep/ .el-tabs__nav-wrap::after {
  background-color: #ffffff;
}
/deep/ .el-tabs__active-bar {
  width: 3.5rem !important;
  height: 0.25rem !important;
  margin-left: 3.5rem !important;
}
/* 按钮组件距离tabs栏的距离和位置center */
.center {
  text-align: center;
  padding-top: 2rem;
}
.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
}
/* 左右选择图标 */
/deep/ .el-icon-arrow-right:before {
  content: none;
}
/deep/ .el-icon-arrow-left:before{
  content: none;
}

/deep/ .tabs_item {
  height: 90%;
}
</style>
